import { render, staticRenderFns } from "./PublicationDashboard.vue?vue&type=template&id=2d9e03b8&scoped=true"
import script from "./PublicationDashboard.vue?vue&type=script&lang=js"
export * from "./PublicationDashboard.vue?vue&type=script&lang=js"
import style0 from "./PublicationDashboard.vue?vue&type=style&index=0&id=2d9e03b8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9e03b8",
  null
  
)

export default component.exports